import connect from './connect'
import MeasurementsPage from './MeasurementsPage'

export default connect(MeasurementsPage)
